import React, { useEffect, useState } from "react";
import { View } from "react-native";
import { theme } from "../../../../theme";
export const InputButtonText = ({ children: [text, button], ...props }) => {
    const [buttonWidth, setButtonWidth] = useState(0);
    useEffect(() => {
        if (button.props.size !== "small") {
            console.error("Cannot compose InputText with a button larger than 'small'");
        }
    }, [button.props.size]);
    return (React.createElement(View, { ...props },
        React.cloneElement(text, {
            styles: [
                {
                    borderTopRightRadius: theme.spacing.medium,
                    borderBottomRightRadius: theme.spacing.medium,
                    paddingRight: buttonWidth + theme.spacing.xsmall,
                },
                text.props.styles,
            ],
        }),
        React.createElement(View, { onLayout: (event) => setButtonWidth(event.nativeEvent.layout.width), style: { position: "absolute", right: 0 } }, React.cloneElement(button, {
            size: "small",
            styles: { margin: 0 },
        }))));
};
//# sourceMappingURL=InputButtonText.js.map